import React from "react";

const Logout = ({onLogout}) => {

    return (
        <button className="btn btn-danger w-100 mt-2" onClick={onLogout}>Выйти</button>
    )
}

export default Logout;